import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=67619b7f&scoped=true&"
import script from "./WizardStep.vue?vue&type=script&lang=ts&"
export * from "./WizardStep.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=67619b7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67619b7f",
  null
  
)

export default component.exports